import { get, set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import RSVP from 'rsvp';
import adminUserValidation from '../../../validations/admin/user';

export default Route.extend({
  abilities: service(),
  fundsService: service(),
  navbarSettings: service(),
  router: service(),
  storeCache: service(),

  beforeModel(transition) {
    if (this.abilities.noAbility('admin_edit_users')) {
      transition.abort();
      return;
    }
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    let storeCache = this.storeCache;
    let promise = RSVP.hash({
      users: storeCache.findAll('admin/user'),
      roles: storeCache.findAll('admin/role'),
    });
    return promise.then((data) => {
      let model = data.users.find((user) => {
        return get(user, 'id') === params.id;
      });
      let validationInstance = adminUserValidation({ allUsers: data.users });
      let changeset = new Changeset(
        model || {},
        lookupValidator(validationInstance),
        validationInstance,
      );
      return {
        model: model,
        changeset: changeset,
        roles: data.roles,
      };
    });
  },

  afterModel(model) {
    if (isEmpty(model.model)) {
      this.router.transitionTo('admin.users.not-found');
    } else {
      set(this, 'navbarSettings.title', get(model, 'model.displayName'));
    }
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
